export function percentageInversion(percentage: string): string {
  return (100 - Number(percentage)).toFixed(2)
}
